module.exports = __webpack_public_path__ + "img/yt-hero1-1-desktop-eng.8cce21be.png";